/**
 * 新增或修改组件接口管理配置
 * Bai.Zhiming
 * 2019-6-5
 */
angular.module("createThirdPartyConfigModule", []).
controller("createThirdPartyConfigCtrl", ["$scope", "$element", "$validation", "$modalInstance", "item", "siteId", function($scope, $element, $validation, $modalInstance, item, siteId) {
    initStatus();
    initData();
    /**
     * [cancel description] 关闭弹窗
     * @return {[type]} [description]
     */
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };
    /**
     * [confirm description] 确定
     * @return {[type]} [description]
     */
    $scope.confirm = function() {
        $validation.validate($scope.createThirdPartyConfigForm).success(() => {
            $modalInstance.close(angular.copy($scope.data.item));
        }).error(() => {
            angular.invalidPosition($scope.createThirdPartyConfigForm, $element);
        });
    };
    /**
     * [initStatus description] 初始化状态
     * @return {[type]} [description]
     */
    function initStatus() {
        $scope.status = {
            isCreate: !item
        }
        $scope.data = {
            item: item
        }
    }
    /**
     * [initData description] 初始化数据
     * @return {[type]} [description]
     */
    function initData() {}
}]);